export const ORANGE = 'orange';
export const REVERSE_ORANGE = 'reverse-orange';
export const REVERSE_RED = 'reverse-red';
export const REVERSE_GREEN = 'reverse-green';
export const MODAL = 'modal';
export const SMALL = 'small';
